import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Subscription, Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { IntegratedAdmissionAppointmentPlan } from "src/app/model/integrated-admission/integrated-admission-appointment-plan";
import { PracticeRegionSearchReservation } from "src/app/model/practice-region-reservation";
import { ValorizationEdit } from "src/app/model/valorization-edit";
import { ValorizationItemAmount } from "src/app/model/valorization-item";
import { ValorizationItemAmountEditDialogComponent } from "../../dialogs/valorization/valorization-item-amount-edit/valorization-item-amount-edit-dialog.component";
import { IntegratedAdmissionWizardService } from "../../integrated-admission/service/integrated-admission-wizard.service";
import { BudgetWizardService } from "../services/budget.wizard.service";

@Component({
  selector: "app-budget-valorization",
  templateUrl: "./budget-valorization.component.html",
  styleUrls: ["./budget-valorization.component.css"],
})
export class BudgetValorizationComponent implements OnInit, OnDestroy {
  valorizationEdit: ValorizationEdit;
  displayedColumns = ["name", "quantity", "amount", "star"];
  currentProceduresSubscription: Subscription;
  currentValorizationSubscription: Subscription;
  currentLoadingValorizationSubscription: Subscription;
  procedures: PracticeRegionSearchReservation[] = [];
  filterCompletePosiblePractices: Observable<PracticeRegionSearchReservation[]>;
  plan: IntegratedAdmissionAppointmentPlan;
  form: FormGroup;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private service: BudgetWizardService
  ) {
    this.form = this.formBuilder.group({
      Procedure: [null],
    });

    this.subscribeEvents();
  }

  get items() {
    return this.valorizationEdit &&
      this.valorizationEdit.ValorizationAmount &&
      this.valorizationEdit.ValorizationAmount.ValorizationItemsAmount
      ? this.valorizationEdit.ValorizationAmount.ValorizationItemsAmount
      : [];
  }

  ngOnInit() {}

  private subscribeEvents() {

    this.currentLoadingValorizationSubscription = this.service.currentLoadingValorizationSubject$.subscribe(
      (loading) => {
        this.loading = loading;
      }
    );

    this.currentProceduresSubscription =
      this.service.currentProceduresSubject$.subscribe((procedures) => {
        this.procedures = procedures;
      });

    this.currentValorizationSubscription =
      this.service.currentValorizationSubject$.subscribe((valorization) => {


        this.valorizationEdit = valorization;
      });

    this.filterCompletePosiblePractices =
      this.form.controls.Procedure.valueChanges.pipe(
        startWith<string | PracticeRegionSearchReservation>(""),
        map((value) =>
          typeof value === "string" ? value : value ? value.Name : ""
        ),
        map((name) => this.filterPosiblePractices(name))
      );

    this.form.controls.Procedure.valueChanges.subscribe((value) => {
      if (value && typeof value !== "string") {
        this.service.setProcedureSelected(value);
        this.form.patchValue(
          {
            Procedure: [null],
          },
          { emitEvent: false }
        );
      }
    });
  }

  getName(item: ValorizationItemAmount): string {
    return item.ValorizationItem.MedicalAppointmentProcedure
      .PracticeRegionAditionalId
      ? item.ValorizationItem.MedicalAppointmentProcedure
          .PracticeRegionAditionalName
      : item.ValorizationItem.MedicalAppointmentProcedure.PracticeRegionName;
  }

  getQuantity(item: ValorizationItemAmount): number {
    return item.ValorizationItem.MedicalAppointmentProcedure.Quantity;
  }

  getPatientAmount(item: ValorizationItemAmount): number {
    return (
      this.getQuantity(item) * (item.PatientAmount + item.PatientTaxAmount)
    );
  }

  public displayPosiblePracticesFn(
    item?: PracticeRegionSearchReservation
  ): string | undefined {
    return item ? item.Name : undefined;
  }

  canRemove(item: ValorizationItemAmount): boolean {
    return item.ValorizationItem.MedicalAppointmentProcedure.Id === 0;
  }

  getTotal(): number {
    const total = this.items.reduce(
      (total, item) => total + this.getPatientAmount(item),
      0
    );

    return Number(total.toFixed(2));
  }

  remove(item: ValorizationItemAmount) {
    this.service.removeValorizationItem(item);
  }

  edit(item: ValorizationItemAmount): void {
    const dialogRef = this.dialog.open(
      ValorizationItemAmountEditDialogComponent,
      {
        width: "50%",
        data: {
          item,
          noUpdateLikeParticular: true,
        },
      }
    );

    dialogRef.afterClosed().subscribe(async (value: any) => {
      if (value) {
        this.service.refreshValorizationItem(value.item);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.currentProceduresSubscription) {
      this.currentProceduresSubscription.unsubscribe();
    }

    if (this.currentValorizationSubscription) {
      this.currentValorizationSubscription.unsubscribe();
    }
  }

  filterPosiblePractices(
    seachText?: string
  ): PracticeRegionSearchReservation[] {
    return seachText
      ? this.procedures.filter(
          (option) =>
            option && this.coincideFilter(option, seachText.split(" "))
        )
      : this.procedures
      ? this.procedures.slice()
      : [];
  }

  coincideFilter(
    practiceRegionSearchReservation: PracticeRegionSearchReservation,
    filters: string[]
  ): boolean {
    let response = true;
    filters.forEach((filter) => {
      if (
        filters.length === 1 &&
        practiceRegionSearchReservation.Code &&
        practiceRegionSearchReservation.Code === filter
      ) {
        response = true;
      } else if (
        response &&
        practiceRegionSearchReservation.SeachText.toLowerCase().indexOf(
          filter.toLowerCase()
        ) < 0
      ) {
        response = false;
      }
    });

    return response;
  }
}
